// Short cooking-reel video player for a given meal.
// Videos live at /videos/<mealId>.mp4 served statically alongside the
// client bundle. If the file is missing the player hides itself via onError.
//
// Props:
//   mealId      — used to build the video src path
//   accentColor — border/button accent (defaults to white for dark card BGs)

import { useState } from "react";

export function VideoReelPlayer({ mealId, accentColor }) {
  const [available, setAvailable] = useState(true);
  const [open, setOpen]           = useState(false);
  if (!available) return null;
  return (
    <div style={{ marginTop: 14 }}>
      {!open ? (
        <button
          onClick={() => setOpen(true)}
          style={{
            width: "100%", padding: "12px 18px", borderRadius: 14,
            background: "rgba(255,255,255,0.15)", border: `1.5px solid ${accentColor || "#fff"}`,
            color: "#fff", cursor: "pointer", display: "flex", alignItems: "center",
            justifyContent: "center", gap: 10, fontSize: 14, fontWeight: 700,
            backdropFilter: "blur(8px)",
          }}
        >
          <span style={{ fontSize: 20 }}>▶️</span>
          Watch the cooking reel
        </button>
      ) : (
        <div style={{ borderRadius: 14, overflow: "hidden", background: "#000", border: `1.5px solid ${accentColor || "#fff"}` }}>
          <video
            src={`/videos/${mealId}.mp4`}
            controls
            autoPlay
            playsInline
            preload="metadata"
            style={{ width: "100%", display: "block", maxHeight: 360 }}
            onError={() => setAvailable(false)}
          />
          <button
            onClick={() => setOpen(false)}
            style={{
              width: "100%", padding: "8px", background: "rgba(255,255,255,0.1)",
              border: "none", color: "rgba(255,255,255,0.7)", cursor: "pointer",
              fontSize: 12, fontWeight: 600,
            }}
          >
            ✕ Close video
          </button>
        </div>
      )}
    </div>
  );
}
